import * as types from '../types/taskTypes';

const initialState = {
  tasks: [],
  task: null,
  stats: null,
  loading: false,
  error: null,
};

function taskReducer(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_TASKS_REQUEST:
    case types.FETCH_TASK_STATS_REQUEST:
    case types.FETCH_TASK_BY_ID_REQUEST:
    case types.CREATE_TASK_REQUEST:
    case types.UPDATE_TASK_REQUEST:
    case types.DELETE_TASK_REQUEST:
      return { ...state, loading: true, error: null };
    case types.FETCH_TASKS_SUCCESS:
      return { ...state, loading: false, tasks: action.payload };
    case types.FETCH_TASK_STATS_SUCCESS:
      return { ...state, loading: false, stats: action.payload };
    case types.FETCH_TASK_BY_ID_SUCCESS:
      return { ...state, loading: false, task: action.payload };
    case types.CREATE_TASK_SUCCESS:
      return { ...state, loading: false, tasks: [...state.tasks, action.payload] };
    case types.UPDATE_TASK_SUCCESS:
      const updated = action.payload;
      return {
        ...state,
        loading: false,
        tasks: state.tasks.map((t) => (t._id === updated._id ? updated : t)),
        task: state.task && state.task._id === updated._id ? updated : state.task,
      };
    case types.DELETE_TASK_SUCCESS:
      return {
        ...state,
        loading: false,
        tasks: state.tasks.filter((t) => t._id !== action.payload),
        task: state.task && state.task._id === action.payload ? null : state.task,
      };
    case types.FETCH_TASKS_FAILURE:
    case types.FETCH_TASK_STATS_FAILURE:
    case types.FETCH_TASK_BY_ID_FAILURE:
    case types.CREATE_TASK_FAILURE:
    case types.UPDATE_TASK_FAILURE:
    case types.DELETE_TASK_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
}

export default taskReducer;
